export default __webpack_public_path__ + "static/media/Icon.0ef91c49.png";